// @flow

export const vizQueryToUrl = (vizQuery: { [key: string]: string }) => {
  const entries = Object.entries(vizQuery);
  if (entries.length < 1) {
    return '';
  }
  return `?:${entries.map(entry => `${entry[0]}=${entry[1]}`).join('&:')}`;
};

export const buildVizUrl = (vizUrl: string, vizQuery: ?{ [key: string]: string }) => {
  if (!vizQuery) {
    return vizUrl;
  }
  return encodeURI(`${vizUrl}${vizQueryToUrl(vizQuery)}`);
};
